import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export const img = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const rm = (v) =>
  `RM ${Number(v || 0).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-MY", { dateStyle: "medium", timeStyle: "short" }) : "-");

export async function downloadCsv(path, name) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function useSeo(title, description, jsonLd) {
  if (typeof document === "undefined") return;
  document.title = title ? `${title} | DDVINTAGE CO` : "DDVINTAGE CO — Vintage, Lifestyle & Digital Top-Ups Malaysia";
  const set = (sel, attr, val, create) => {
    let el = document.head.querySelector(sel);
    if (!el) {
      el = document.createElement(create.tag);
      Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
      document.head.appendChild(el);
    }
    el.setAttribute(attr, val);
  };
  const path = window.location.pathname;
  set('meta[name="description"]', "content", description || "Vintage finds, fashion, home, gadgets and digital top-ups (games and gift cards) in Malaysia.", { tag: "meta", attrs: { name: "description" } });
  set('meta[property="og:title"]', "content", document.title, { tag: "meta", attrs: { property: "og:title" } });
  set('meta[property="og:description"]', "content", description || "", { tag: "meta", attrs: { property: "og:description" } });
  set('link[rel="canonical"]', "href", `https://ddvintage.co${path}`, { tag: "link", attrs: { rel: "canonical" } });
  set('link[hreflang="en"]', "href", `https://ddvintage.co${path}`, { tag: "link", attrs: { rel: "alternate", hreflang: "en" } });
  set('link[hreflang="ms"]', "href", `https://ddvintage.co${path}?lang=bm`, { tag: "link", attrs: { rel: "alternate", hreflang: "ms" } });
  let ld = document.getElementById("ld-json");
  if (jsonLd) {
    if (!ld) {
      ld = document.createElement("script");
      ld.id = "ld-json";
      ld.type = "application/ld+json";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(jsonLd);
  } else if (ld) ld.remove();
}
